<template>
    <tr
        v-if="!isBeingEdited"
        class="kgr-table__row"
    >
        <td class="kgr-table__cell">
            {{ classification.parameterValue.value }}
        </td>
        <td class="kgr-table__cell">
            {{ classification.start }}
        </td>
        <td class="kgr-table__cell">
            {{ classification.end }}
        </td>
        <td
            class="kgr-table__cell notice"
            v-html="notice"
        ></td>
        <td class="kgr-table__cell kgr-table__cell--actions">
            <kgr-icon-edit
                v-if="isEditable"
                :size="15"
                class="kgr-table__action"
                @click="$emit('edit')"
            />
            <kgr-icon-delete
                v-if="isDeletable"
                class="kgr-table__action"
                @click="$emit('remove')"
            />
        </td>
    </tr>
</template>

<script>
import IconDelete from '../../common/icon/IconDelete';
import IconEdit from '../../common/icon/IconEdit';
import MemberClassification from '../../../js/dto/MemberClassification';

export default {
    components: {
        'kgr-icon-edit': IconEdit,
        'kgr-icon-delete': IconDelete,
    },
    props: {
        classification: {
            type: MemberClassification,
            required: true
        },
        editClassifications: {
            type: Array,
            required: true
        },
        isEditable: {
            type: Boolean,
            required: true,
        },
        isDeletable: {
            type: Boolean,
            required: true,
        },
    },
    computed: {
        isBeingEdited() {
            return this.editClassifications.map(editClassification => editClassification.id).indexOf(this.classification.id) !== -1;
        },
        notice() {
            return null === this.classification.notice ? '' : this.classification.notice.replace('\n', '<br>');
        },
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
    .notice {
        white-space: pre-line;
    }

    .kgr-table__cell {
        vertical-align: top;
    }
</style>
